import { fetcher } from '@commenda/utils';
import { UserEntityLinkRole } from '@prisma/client';

export async function updateCompanyMember(
  companyId: number,
  userId: string,
  body: { name?: string; role?: UserEntityLinkRole }
): Promise<Response> {
  return fetcher(`company/${companyId}/member/${userId}`, {
    method: 'POST',
    body,
  });
}
